import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {PrimeNG} from 'primeng/config';

// Each language is written in its own language, so that a user who does not read the current one can still find theirs.
export const LANGUAGES = [
    {code: 'fr', label: 'Français'},
    {code: 'en', label: 'English'},
    {code: 'it', label: 'Italiano'},
];

@Injectable({
    providedIn: 'root',
})
export class LangService {
    readonly langListOrigin = ['fr', 'en', 'it'] as const;
    currentLang: string;
    currentLang$: BehaviorSubject<string>;

    constructor(private readonly translate: TranslateService,
                private config: PrimeNG) {
        this.currentLang$ = new BehaviorSubject('fr');
    }

    private normalizeLang(lang: string): string {
        const normalized = (lang || '').toLowerCase();
        return this.langListOrigin.includes(normalized as any) ? normalized : 'fr';
    }

    applyUserLanguage(langKey: string): void {
        const lang = this.normalizeLang(langKey);
        this.currentLang = lang;
        localStorage.setItem('lang', lang);
        this.translate.setDefaultLang('fr');
        this.translate.use(lang).subscribe(() => {
            this.translate.get('primeng').subscribe(res => this.config.setTranslation(res));
            this.currentLang$.next(this.currentLang);
        });
    }

    init() {
        this.applyUserLanguage(localStorage.getItem('lang'));
    }

    /**
     * Loads translations for the best-known language (localStorage, else 'fr') synchronously
     * with app bootstrap, so routed components never render before translations are available.
     */
    preload(): Observable<any> {
        const lang = this.normalizeLang(localStorage.getItem('lang'));
        this.currentLang = lang;
        this.translate.setDefaultLang('fr');
        return this.translate.use(lang);
    }

    changeLang(lang: string, init = true) {
        this.applyUserLanguage(lang);
        if (!init) {
            location.reload();
        }
    }
}
